 
import { renderPage } from "../utils/helper";

 

/* ================= INIT ================= */
document.addEventListener("DOMContentLoaded", () => {
  const keyName = document.getElementById('dataKey')?.name
  renderPage(keyName);
});
